import { ReactNode } from 'react';
import { isFragment } from 'react-is';
import devLogger from 'react-utils/devLogger';

export const warnIfFragment = (
  node: ReactNode,
  componentName: string,
  propName = 'children'
): void => {
  if (process.env.NODE_ENV !== 'production' && isFragment(node)) {
    devLogger.warn({
      message: `${componentName}: ${propName} cannot be a React.Fragment. Please refactor to use a DOM node.`,
      key: `${componentName}: fragment not supported`,
    });
  }
};
